/*
  assets/tcx-npe-picker.js (NPE v5.55)
  v5.55: the per-Totem quick picker. Tap (or click) a skin or necklace swatch in
  "What you get", or its "Tap to change": a picker for that Totem with the big
  images, the name, Included or the extra cost and every option by group.
  Desktop: hover previews, a click picks and closes. Phones: a sheet from the
  bottom; a tap previews, Confirm picks, "Use for all" sets every Totem.
  Built on window.TCX (options / setPicks), so it never touches the NPE's own
  modal. Moved here from tcx-sticky-bar-v6 (rounds 41-47).
*/
(function () {
  var npe = document.querySelector('[data-tcx]');
  if (!npe || !window.TCX || window.__tcxPk) return; window.__tcxPk = true;
  var html = document.documentElement;
  var data = { skins: null, necklaces: null };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function scrape(kind) { return window.TCX.options(kind); }
  function setValues(kind, pairs) { window.TCX.setPicks(kind, pairs); }
  // skins: round swatches like the buy box; necklaces: the chain zoomed in
  function swatch(o, kind) {
    var k = kind === 'necklaces' ? ' tcx-pk__sw--neck' : ' tcx-pk__sw--skin';
    if (!o) return '<span class="tcx-pk__sw' + k + '"></span>';
    if (o.img) return '<span class="tcx-pk__sw' + k + '"><img src="' + esc(o.img) + '" alt="" loading="lazy"' + (o.zoom > 1 ? ' style="transform:scale(' + o.zoom + ')"' : '') + '></span>';
    return '<span class="tcx-pk__sw' + k + '" style="' + esc(o.style) + '"></span>';
  }
    // ======================= round 41: the per-Totem picker =======================
    // Tapping a skin or necklace swatch in the buy box's "Here's what you get" opens a picker for that Totem: the big
    // images (front and back of a skin; a necklace's close-up and the chain on the Compass), the name, Included or
    // the extra cost, and every option by group. Desktop: hovering an option previews it, a click picks it (the
    // picker stays open; the arrows step to the next Totem). Phones: a sheet from the bottom; a tap previews, Confirm
    // picks. Tapping outside, Esc or the arrows keep (save) whatever was picked. Changes go through window.TCX.setPicks
    // (v5.55), so the buy box, its URL and the cart all follow.
    var DET = {}; try { DET = JSON.parse((document.getElementById('tcx-detail-map') || {}).textContent || '{}'); } catch (e) {}
    var SDESC = {}; try { SDESC = JSON.parse((document.getElementById('tcx-shortdesc-map') || {}).textContent || '{}'); } catch (e) {}
    var pk = null, pkHover = null;
    var phoneQ = window.matchMedia ? window.matchMedia('(max-width: 749px), (hover: none)') : { matches: false };
    var pkEl = document.createElement('div');
    pkEl.className = 'tcx-pk'; pkEl.hidden = true;
    pkEl.innerHTML = '<div class="tcx-pk__scrim" data-tcx-pk-x></div><div class="tcx-pk__card" role="dialog" aria-label="Choose"><div class="tcx-pk__top">' +
      '<button type="button" class="tcx-pk__nav" data-tcx-pk-nav="-1" aria-label="Previous Totem">‹</button><b class="tcx-pk__who"></b>' +
      '<button type="button" class="tcx-pk__nav" data-tcx-pk-nav="1" aria-label="Next Totem">›</button><button type="button" class="tcx-pk__x" data-tcx-pk-x aria-label="Close">✕</button></div>' +
      '<div class="tcx-pk__view" aria-live="polite"></div><div class="tcx-pk__opts"></div>' +
      '<div class="tcx-pk__foot"><button type="button" class="tcx-pk__all" data-tcx-pk-all></button><button type="button" class="tcx-pk__ok" data-tcx-pk-ok>Confirm</button></div></div>';
    document.body.appendChild(pkEl);
    var pkCard = pkEl.querySelector('.tcx-pk__card');
    function detFor(name) {
      var n = String(name || '').toLowerCase().replace(/'/g, ''); if (!n) return null;
      if (DET[n]) return DET[n];
      for (var k in DET) { if (k.length > n.length && k.slice(-(n.length + 3)) === ' - ' + n) return DET[k]; }
      return null;
    }
    function pkView(kind, o) {
      if (!o) return '';
      var d = detFor(o.name), imgs = [];
      if (d) {
        if (kind === 'skins') { if (d.front) imgs.push(d.front); if (d.back) imgs.push(d.back); }
        else { if (d.closeup) imgs.push(d.closeup); if (d.front) imgs.push(d.front); }
      }
      if (!imgs.length && o.img) imgs.push(o.img);
      var desc = kind === 'skins' ? (SDESC.skin || '') : (SDESC['totem-necklaces'] || '');
      var h = '<div class="tcx-pk__imgs tcx-pk__imgs--' + kind + '">';
      imgs.slice(0, 2).forEach(function (u) { h += '<span><img src="' + esc(u) + '" alt=""></span>'; });
      if (!imgs.length) h += '<span>' + swatch(o, kind) + '</span>';
      return h + '</div><div class="tcx-pk__vt"><b>' + esc(o.label || o.name) + '</b><em' + (o.up ? ' class="is-up"' : '') + '>' + esc(o.up || 'Included') + '</em>' + (o.le ? '<em class="tcx-pk__le">Limited Edition</em>' : '') + (desc ? '<p>' + esc(desc) + '</p>' : '') + '</div>';
    }
    function pkCur() { var d = pk && data[pk.kind]; return d ? (pk.pending || d.sel[pk.i]) : null; }
    function pkRender() {
      var d = data[pk.kind];
      if (!d || !d.sel.length) { pkClose(true); return; }
      if (pk.i >= d.sel.length) pk.i = d.sel.length - 1;
      var n = d.sel.length, cur = pkCur();
      pkEl.querySelector('.tcx-pk__who').textContent = (n === 1 ? 'Your Totem' : 'Totem ' + (pk.i + 1) + ' of ' + n) + ' · ' + (pk.kind === 'skins' ? 'Skin' : 'Necklace');
      pkEl.querySelectorAll('[data-tcx-pk-nav]').forEach(function (b) { var dd = +b.getAttribute('data-tcx-pk-nav'); b.disabled = pk.i + dd < 0 || pk.i + dd >= n; b.hidden = n < 2 || !phoneQ.matches; });   // round 43: phones only
      pkEl.querySelector('.tcx-pk__view').innerHTML = pkView(pk.kind, d.byV[pkHover || cur]);
      var h = '';
      d.groups.forEach(function (g) {
        h += '<p class="tcx-pk__og">' + esc(g.label) + '</p><div class="tcx-pk__grid">';
        g.opts.forEach(function (o) {
          h += '<button type="button" class="tcx-pk__o tcx-pk__o--' + pk.kind + '" data-tcx-pk-opt="' + esc(o.v) + '" aria-pressed="' + (o.v === cur) + '" aria-label="' + esc((o.label || o.name) + (o.le ? ', Limited Edition' : '') + (o.up ? ' (' + o.up + ')' : '')) + '">' + swatch(o, pk.kind) + (o.up ? '<em>' + esc(o.up) + '</em>' : '') + '</button>';
        });
        h += '</div>';
      });
      pkEl.querySelector('.tcx-pk__opts').innerHTML = h;
      var all = pkEl.querySelector('[data-tcx-pk-all]');
      all.hidden = n < 2 || !phoneQ.matches; all.textContent = 'Use for all ' + n;
      pkEl.classList.toggle('is-phone', !!phoneQ.matches);
      pkEl.querySelector('[data-tcx-pk-ok]').hidden = !phoneQ.matches;
      pkEl.querySelector('.tcx-pk__foot').hidden = all.hidden && !phoneQ.matches;
    }
    function pkAnchor() {
      var row = npe.querySelector('[data-tcx-selimgs="' + pk.kind + '"]');
      var sw = row ? row.querySelectorAll('.tcx__fsw, .tcx__thumbw') : [];
      return sw[pk.i] || sw[0] || npe.querySelector('[data-tcx-row="' + pk.kind + '"]');
    }
    function pkMark() {
      npe.querySelectorAll('.tcx-pk-on').forEach(function (e) { e.classList.remove('tcx-pk-on'); });
      var a = pk && !pkEl.hidden && pkAnchor(); if (a && a.classList && /tcx__(fsw|thumbw)/.test(a.className)) a.classList.add('tcx-pk-on');
    }
    function pkPlace() {
      if (!pk || pkEl.hidden) return;
      pkMark();
      if (phoneQ.matches) { pkCard.style.left = pkCard.style.top = ''; return; }
      var a = pkAnchor(); if (!a) return;
      var r = a.getBoundingClientRect(), w = pkCard.offsetWidth || 460, h = pkCard.offsetHeight || 480, vw = document.documentElement.clientWidth, vh = window.innerHeight;
      var left = Math.max(12, Math.min(vw - w - 12, r.left + r.width / 2 - 60));
      var top = r.bottom + 12; if (top + h > vh - 12 && r.top - h - 12 > 60) top = r.top - h - 12; else if (top + h > vh - 12) top = Math.max(60, vh - h - 12);
      pkCard.style.left = left + 'px'; pkCard.style.top = (top + window.pageYOffset) + 'px';
      pkCard.style.setProperty('--ax', Math.max(18, Math.min(w - 18, r.left + r.width / 2 - left)) + 'px');
      pkCard.classList.toggle('is-above', top < r.top);
    }
    function pkCommit() {
      if (!pk || !pk.pending) return;
      var d = data[pk.kind], v = pk.pending; pk.pending = null;
      // round 45: one trip through the buy box's picker, then the pick is noted here (no second read), so taps land fast
      if (d && v !== d.sel[pk.i]) { setValues(pk.kind, [[pk.i, v]]); d.sel[pk.i] = v; }
    }
    function pkOpen(kind, i) {
      data[kind] = scrape(kind);          // round 45: only the list being opened is read
      if (!data[kind] || !data[kind].sel.length) { if (window.TTMPDP && TTMPDP.customize) TTMPDP.customize(null); return; }
      if (pk && !pkEl.hidden) pkCommit();
      pk = { kind: kind, i: i || 0, pending: null }; pkHover = null;
      // round 45: every option's big images are fetched now, so previews swap in instantly (they came in late on phones)
      (pkOpen.pre || (pkOpen.pre = {}));
      data[kind].groups.forEach(function (g) { g.opts.forEach(function (o) { var dd = detFor(o.name); if (!dd) return; [dd.front, dd.back, dd.closeup].forEach(function (u) { if (u && !pkOpen.pre[u]) { var im = new Image(); im.decoding = 'async'; im.src = u; pkOpen.pre[u] = im; } }); }); });
      pkEl.hidden = false;
      pkRender();
      void pkEl.offsetWidth; pkEl.classList.add('is-open');
      pkPlace();
      if (phoneQ.matches) html.classList.add('tcx-pk-lock');
    }
    function pkClose(skipSave) {
      if (!pk || pkEl.hidden) return;
      if (!skipSave) pkCommit();
      pkEl.classList.remove('is-open'); html.classList.remove('tcx-pk-lock');
      npe.querySelectorAll('.tcx-pk-on').forEach(function (e) { e.classList.remove('tcx-pk-on'); });
      setTimeout(function () { if (!pkEl.classList.contains('is-open')) pkEl.hidden = true; }, 220);
    }
    // round 47: on touch screens the picker's buttons act when the finger lifts (iOS sometimes holds back or drops the
    // click, so closing took several taps); the click that follows is then ignored
    var pkTap = null, pkSkip = 0;
    pkEl.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') { pkTap = null; return; }
      var b = e.target.closest && e.target.closest('[data-tcx-pk-x], [data-tcx-pk-ok], [data-tcx-pk-all], [data-tcx-pk-nav], [data-tcx-pk-opt]');
      pkTap = b ? { b: b, x: e.clientX, y: e.clientY } : null;
    });
    pkEl.addEventListener('pointercancel', function () { pkTap = null; });
    pkEl.addEventListener('pointerup', function (e) {
      var t = pkTap; pkTap = null;
      if (!t || Math.abs(e.clientX - t.x) > 12 || Math.abs(e.clientY - t.y) > 12) return;
      if (t.b.disabled || !pkEl.contains(t.b)) return;
      pkSkip = Date.now(); pkAct(t.b);
    });
    pkEl.addEventListener('click', function (e) {
      if (Date.now() - pkSkip < 700) { e.preventDefault(); return; }
      pkAct(e.target);
    });
    function pkAct(t) {
      if (!pk || pkEl.hidden) return;
      if (t.closest('[data-tcx-pk-x]')) { pkClose(); return; }
      var nv = t.closest('[data-tcx-pk-nav]');
      if (nv) { pkCommit(); pk.i += +nv.getAttribute('data-tcx-pk-nav'); pkHover = null; pkRender(); pkPlace(); return; }
      var o = t.closest('[data-tcx-pk-opt]');
      if (o) {
        var v = o.getAttribute('data-tcx-pk-opt');
        pk.pending = v; pkHover = null;
        // round 42: desktop: a click picks it and closes the picker; phones: a tap previews (Confirm picks)
        if (!phoneQ.matches) { pkClose(); return; }
        pkRender(); pkPlace(); return;
      }
      if (t.closest('[data-tcx-pk-ok]')) { pkClose(); return; }
      if (t.closest('[data-tcx-pk-all]')) {
        var d = data[pk.kind], val = pkCur(); if (!d || !val) return;
        pk.pending = null; setValues(pk.kind, d.sel.map(function (_, k) { return [k, val]; })); d.sel = d.sel.map(function () { return val; }); pkClose(true);
      }
    }
    // desktop: hover previews the big images; leaving the options shows the pick again
    pkEl.addEventListener('mouseover', function (e) {
      if (phoneQ.matches) return;
      var o = e.target.closest && e.target.closest('[data-tcx-pk-opt]'), v = o ? o.getAttribute('data-tcx-pk-opt') : null;
      if (v === pkHover) return;
      if (!o && !(e.target.closest && e.target.closest('.tcx-pk__opts'))) { if (pkHover === null) return; }
      pkHover = v;
      var d = data[pk.kind]; if (d) pkEl.querySelector('.tcx-pk__view').innerHTML = pkView(pk.kind, d.byV[v || pkCur()]);
    });
    pkEl.addEventListener('mouseleave', function () { if (pkHover !== null && pk) { pkHover = null; var d = data[pk.kind]; if (d) pkEl.querySelector('.tcx-pk__view').innerHTML = pkView(pk.kind, d.byV[pkCur()]); } });
    // a tap or click anywhere outside closes it (and keeps the pick); a click on another swatch moves it there
    document.addEventListener('pointerdown', function (e) {
      if (!pk || pkEl.hidden) return;
      if (pkCard.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-tcx-selimgs] .tcx__fsw, [data-tcx-selimgs] .tcx__thumbw')) return;
      pkClose();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pk && !pkEl.hidden) pkClose(); });
    window.addEventListener('resize', function () { if (pk && !pkEl.hidden) { pkRender(); pkPlace(); } });
    // the buy box redraws its rows after every change: keep the picked swatch marked
    document.addEventListener('tcx:change', function () { if (pk && !pkEl.hidden) pkMark(); });
    pkEl.addEventListener('touchmove', function (e) { if (!(e.target.closest && e.target.closest('.tcx-pk__card'))) e.preventDefault(); }, { passive: false });


    // a swatch in "What you get" opens that Totem's picker; "Tap to change" opens Totem 1's
    npe.addEventListener('click', function (e) {
      var h = e.target.closest && e.target.closest('[data-tcx-hint]');
      if (h) { e.preventDefault(); e.stopPropagation(); var hk = h.getAttribute('data-tcx-hint'); setTimeout(function () { pkOpen(hk, 0); }, 0); return; }
      var row = e.target.closest && e.target.closest('[data-tcx-row]');
      if (!row) return;
      var kind = row.getAttribute('data-tcx-row');
      if (kind !== 'skins' && kind !== 'necklaces') return;
      var sw = e.target.closest('.tcx__fsw, .tcx__thumbw');
      if (!sw) return;
      e.preventDefault();
      var idx = sw.parentNode ? [].indexOf.call(sw.parentNode.querySelectorAll('.tcx__fsw, .tcx__thumbw'), sw) : 0;
      setTimeout(function () { pkOpen(kind, Math.max(0, idx)); }, 0);
    });
    window.TCX.pick = function (kind, i) { pkOpen(kind || 'skins', i || 0); };
    window.TCX.closePick = pkClose;
})();
